import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NavigationItem} from '../types/navigation.types';

@Component({
  selector: 'cov-sub-navigation-item',
  imports: [CommonModule, RouterLinkActive, RouterLink],
  templateUrl: './sub-navigation-item.component.html',
  styleUrl: './sub-navigation-item.component.scss',
})
export class SubNavigationItemComponent {
  public navItem = input.required<NavigationItem>();
}
